export const GET_AXISCARE_SETUP = "GET_AXISCARE_SETUP"
export const GET_AXISCARE_SETUP_SUCCESS = "GET_AXISCARE_SETUP_SUCCESS"
export const GET_AXISCARE_SETUP_FAILED = "GET_AXISCARE_SETUP_FAILED"

export const GET_AXISCARE_REPORTS = "GET_AXISCARE_REPORTS"
export const GET_AXISCARE_REPORTS_SUCCESS = "GET_AXISCARE_REPORTS_SUCCESS"
export const GET_AXISCARE_REPORTS_FAILED = "GET_AXISCARE_REPORTS_FAILED"

export const INIT_AXISCARE = "INIT_AXISCARE"
export const INIT_AXISCARE_SUCCESS = "INIT_AXISCARE_SUCCESS"
export const INIT_AXISCARE_FAILED = "INIT_AXISCARE_FAILED"
export const RESET_AXISCARE_STATE = "RESET_AXISCARE_STATE"
